import { Component, ChangeDetectorRef } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { ViewportScroller } from '@angular/common';
import { ExaNewMapComponent } from './exa-new-map.component';
import { DialogService } from 'src/app/services/dialog.service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { AppCacheService } from 'src/app/services/app-cache.service';
import { LogService } from 'src/app/services/log.service';
import { PoiEditComponent } from '../popover/poi-edit/poi-edit.component';
import { Platform, PopoverController } from '@ionic/angular';
import { POIDto } from 'src/app/api/exa';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'exa-map',
  templateUrl: './exa-new-map.component.html',
  styleUrls: ['./exa-new-map.component.scss'],
})
export class MapComponent extends ExaNewMapComponent {
  override buttonDisabledClass = 'fab-button-disabled';

  constructor(
    private ___logService: LogService,
    private ___translateService: TranslateService,
    private ___changeDetectorRef: ChangeDetectorRef,
    private __cache: AppCacheService,
    private __sanitizer: DomSanitizer,
    private _httpClient: HttpClient,
    private popoverCtrl: PopoverController,
    private alertService: AlertService,
    private __platform: Platform,
    private _viewportScroller: ViewportScroller,
    private dialogService: DialogService
  ) {
    super('MapComponent', ___logService, ___translateService, ___changeDetectorRef, __cache, __sanitizer, _httpClient, __platform, _viewportScroller);

    if (this._options) {
      if (this.mapOptions.mapId) {
        this.mapOptions.mapId = this._options.mapId;
      }
      this.mapOptions.fullscreenControl = this._options.fullscreenControl;
      this.mapOptions.zoomControl = this._options.zoomControl;
      this.mapOptions.mapTypeControl = this._options.mapTypeControl;
    }

  
  }

  async showPOIEditDialog(ev?: Event) {
    const popover = await this.popoverCtrl.create({
      component: PoiEditComponent,
      animated: true,
      showBackdrop: true,
      cssClass: 'custom-popover',
      event: ev,
      keyboardClose: false, 
      backdropDismiss: true
    });

    // Listen for keyboard events and adjust popover position
    window.addEventListener('keyboardDidShow', () => {
      const popoverEl = document.querySelector('.custom-popover');
      if (popoverEl) {
        (popoverEl as HTMLElement).style.transform = 'translateY(-20%)';
      }
    });

    window.addEventListener('keyboardDidHide', () => {
      const popoverEl = document.querySelector('.custom-popover');
      if (popoverEl) {
        (popoverEl as HTMLElement).style.bottom = '';
        (popoverEl as HTMLElement).style.transform = '';
      }
    });

    popover.onDidDismiss().then((data) => {
      if (data.data) {
      this.addPOIData(data.data as POIDto);
      this.alertService.openNoticeToast(this.___translateService.instant('GEOMETRY.CLICK_TO_SAVE'), 3000, 'light')
      }
    });
    return await popover.present();
  }

  
}
